export default __webpack_public_path__ + "static/media/branch-pin.c6adbb5d.svg";